import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';
import gsap from "gsap";

class ReferenceSlider {
  constructor() {
    ReferenceSlider.referencesSlider();
    ReferenceSlider.referenceHover();
  }

  static referenceHover() {
    window.bgReveal = (e) => {
      const offset = 100; // offset around element
      const rect = e.target.getBoundingClientRect();
      const newX = e.offsetX;
      const newY = e.offsetY;

      if(newX < -offset || newX > (rect.width + offset)){
        e.target.style.setProperty('--bgOpacity', 0);
        return;
      }

      const x = e.offsetX;

      if(newY < -offset || newY > (rect.height + offset)){
        e.target.style.setProperty('--bgOpacity', 0);
        return;
      }

      const y = e.offsetY;

      e.target.style.setProperty('--bgX', `${x}px`);
      e.target.style.setProperty('--bgY', `${y}px`);
    };

    [].forEach.call(window.wrapper.querySelectorAll('a.card--reference'), (link) => {
      link.addEventListener('mousemove', window.bgReveal);
    });
  }

  static referencesSlider() {
    const Gn = function (t) {
      const e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      return Math.max(e, Math.min(i, t))
    };

    const lerp = (t, e, i) => (e - t) * i + t;

    [].forEach.call(window.wrapper.querySelectorAll('.references__slider'), (slider) => {
      const { id } = slider.dataset;
      const slides = slider.querySelectorAll('.swiper-slide');
      const cards = slider.querySelectorAll('.card');

      let spaceBetween = 15;
      if(window.innerWidth >= 768){
        spaceBetween = 30;
      }

      this.isMoving = false;
      const _this = this;
      const nextEl = slider.querySelector(`[data-prev="${id}"]`);
      const prevEl = slider.querySelector(`[data-next="${id}"]`);

      const getValues = () => {
        this.slideWidth = Math.round(slides[0].offsetWidth + spaceBetween);
        this.offsetAfter = parseFloat(window.getComputedStyle(slider.querySelector('.swiper-wrapper')).marginLeft);
      }
      getValues();

      return new Swiper(slider, {
        modules: [Navigation, Keyboard, A11y],
        slidesPerView: "auto",
        grabCursor: true,
        slideToClickedSlide: true,
        spaceBetween,
        speed: 400,
        keyboard: true,
        touchRatio: 0.85,
        roundLengths: false,
        slidesOffsetAfter: _this.offsetAfter + (slides.length > 3 ? _this.slideWidth : 0),
        navigation: {
          nextEl,
          prevEl
        },
        breakpoints: {
          992: {
            speed: 600,
            slideToClickedSlide: false,
            roundLengths: true
          }
        },
        on: {
          setTranslate(swiper, translate) {
            const n = Math.floor(translate / -_this.slideWidth);
            const r = window.innerWidth < 768 ? 20 : 40;
            slides.forEach(((slide, index) => {
              const o = index <= n ? Math.abs(index * _this.slideWidth + translate) : 0;
              const a = Gn(o / _this.slideWidth, 0, 2);
              const l = lerp(0, _this.slideWidth - r, a);
              const u = lerp(1, .75, a);
              const c = lerp(1, 0, Math.max(0, a - 1));
              const h = lerp(1, 0, a);
              gsap.set(slide,
                {
                  autoAlpha: c,
                  x: l,
                  scale: u,
                  force3D: true
                });

              gsap.set(cards[index],
                {
                  autoAlpha: h
                })
            }));
          },
          sliderMove() {
            if(!_this.isMoving){
              _this.isMoving = true;
              slider.classList.add("is-dragged");
            }
          },
          touchEnd() {
            _this.isMoving = false;
            slider.classList.remove("is-dragged");
          },
          click(swiper, event) {
            if (swiper.activeIndex >= (slides.length - 2)){
              event.preventDefault();
              event.stopPropagation();
              swiper.slideTo(swiper.activeIndex);
              return false;
            }
          },
          slideChangeTransitionStart(swiper) {
            if (swiper.activeIndex >= (slides.length - 2)){
              nextEl.classList.add('swiper-button-disabled');
            } else {
              nextEl.classList.remove('swiper-button-disabled');
            }
          },
          resize(swiper) {
            getValues();
            swiper.params.slidesOffsetAfter = _this.offsetAfter + (slides.length > 3 ? _this.slideWidth : 0);
            swiper.update();
          }
        }
      });
    });
  }
}

export default ReferenceSlider;
